var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2759 16.625V21.625C22.2759 22.7296 21.3804 23.625 20.2759 23.625H9.27588C8.17131 23.625 7.27588 22.7296 7.27588 21.625V16.6769",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7759 6.125H16.7759C17.6043 6.125 18.2759 6.79657 18.2759 7.625V8.125H11.2759V7.625C11.2759 6.79657 11.9475 6.125 12.7759 6.125Z",
    stroke: "#76BC21"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.27588,
    y: 8.625,
    width: 17,
    height: 8,
    rx: 2,
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2759,
    y: 15.1875,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#76BC21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateAccountIcon);
export default __webpack_public_path__ + "static/media/corporateAccountIcon.d52bc80bf3439d989cdb000478f0b9c6.svg";
export { ForwardRef as ReactComponent };